import { Component, Input, OnInit } from '@angular/core';
import { CourseEventViewModel, EventViewModel } from 'src/app/_models/generatedModels';
import { EventService } from 'src/app/_services/generatedServices';
import { SettingsProvider } from "../../../_services/settingsProvider.service";

@Component({
  selector: 'bxl-chat-event-link',
  templateUrl: 'chat-event-link.component.html',
})
export class ChatEventLinkComponent implements OnInit {
  initialized = false;

  @Input() eventIdOrSlug: string;
  evt: CourseEventViewModel;

  constructor(private eventService: EventService, public settings:SettingsProvider) {}

  ngOnInit(): void {
    this.eventService.getSpecificCourseEvent(this.eventIdOrSlug).subscribe((evt) => {
      this.evt = evt;
      this.initialized = true;
    });
  }
}
